__turbopack_context__.v({
  "button": "PopoverMenu-module-scss-module__0Z4hNG__button",
  "fade-in": "PopoverMenu-module-scss-module__0Z4hNG__fade-in",
  "foldout": "PopoverMenu-module-scss-module__0Z4hNG__foldout",
  "foldoutAnchorWidth": "PopoverMenu-module-scss-module__0Z4hNG__foldoutAnchorWidth",
  "headerMenu": "PopoverMenu-module-scss-module__0Z4hNG__headerMenu",
  "link": "PopoverMenu-module-scss-module__0Z4hNG__link",
  "list": "PopoverMenu-module-scss-module__0Z4hNG__list",
  "nav": "PopoverMenu-module-scss-module__0Z4hNG__nav",
  "no-transform": "PopoverMenu-module-scss-module__0Z4hNG__no-transform",
  "notificationCount": "PopoverMenu-module-scss-module__0Z4hNG__notificationCount",
  "rotate": "PopoverMenu-module-scss-module__0Z4hNG__rotate",
});
